<!-- <div class="navigation-container" [class.with-shadow]="hasShadow" *ngIf="username"> -->
  <div class="navigation-container" [class.with-shadow]="hasShadow">
    <div class="left-nav">
      <!-- Mobile menu button -->
      <button 
        class="mobile-menu-btn" 
        (click)="toggleSidebar.emit()"
        aria-label="Toggle sidebar"
      >
        <img src="assets/custom-icons/mobilemenu.svg" alt="Menu" />
      </button>
      
      <span class="logo desktop-logo" (click)="newChat.emit()" style="cursor:pointer">FIGPT</span>
      <span class="logo mobile-logo" (click)="newChat.emit()" style="cursor:pointer">FIGPT</span>
    </div>
    
    <!-- Right side - New Chat button for mobile -->
    <div class="right-nav">
      <button 
        class="mobile-newchat-btn" 
        (click)="newChat.emit()"
        aria-label="New Chat"
      >
        <img src="assets/custom-icons/newchat.svg" alt="New Chat" />
      </button>
    </div>
  </div>
  